import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueClipboard from 'vue-clipboard2' //复制API
import mintUI from './config/mintUI.scss'
require('es6-promise').polyfill()
require('isomorphic-fetch')
import Chain33Rpc from 'chain33-rpc-api'
import filters from './assets/js/filter'
import VueProgressiveImage from 'vue-progressive-image'

const URL = 'https://jiedian1.bityuan.com:8801/' //chain33交易查询API
// const URL = 'https://mainnode.bityuan.com:8801' // 主链备用

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])  //注册全局filter；
})

Vue.use(VueProgressiveImage)
Vue.use(VueClipboard)
Vue.use(mintUI)
Vue.prototype.$chain33Rpc = new Chain33Rpc(URL)
new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
